import React, { Component } from 'react';

import classes from './Input.module.css';

export default class Input extends Component {
  state = {
    showPasswordText: false,
  };

  _togglePasswordText = () => {
    this.setState({ showPasswordText: !this.state.showPasswordText });
  };

  _renderEyeButton = () => {
    if (this.props.type === 'password') {
      const eyeButtonClass = this.props.showRedTriangle
        ? [classes.EyeButton, classes.EyeButtonWithTriangle].join(' ')
        : classes.EyeButton;

      return (
        <div className={eyeButtonClass} onClick={this._togglePasswordText}>
          <svg className={classes.Eye}>
            {!this.state.showPasswordText ? (
              <use xlinkHref='/sprites.svg#icon-visibility' />
            ) : (
              <use xlinkHref='/sprites.svg#icon-visibility-off' />
            )}
          </svg>
        </div>
      );
    }
  };

  _renderRedTriangle = () => {
    if (this.props.showRedTriangle) {
      return (
        <div className={classes.RedTraingleWrapper}>
          <svg className={classes.RedTraingle}>
            <use xlinkHref='/sprites.svg#red-triangle' />
          </svg>
        </div>
      );
    }
  };

  _renderLabel = () => {
    const labelSmall = this.props.labelSmall ? (
      <small className={classes.LabelSmall}>{this.props.labelSmall}</small>
    ) : (
      ''
    );

    if (this.props.displayAsTwoLabels) {
      return (
        <div className={classes.LabelWrapper}>
          <label
            className={[classes.Label, classes.LabelLeft].join(' ')}
            style={this.props.inputLabelStyle}
          >
            {this.props.label}&nbsp; {labelSmall}
          </label>
          <span className={classes.LabelRight}>
            {this.props.displayAsTwoLabels}
          </span>
        </div>
      );
    } else {
      return (
        <label className={classes.Label} style={this.props.inputLabelStyle}>
          {this.props.label}
          {this.props.labelNextLine ? <br /> : ' '}
          {labelSmall}
        </label>
      );
    }
  };

  _renderSmallTextBottomLeft = () => {
    if (this.props.smallTextBottomLeft) {
      return (
        <div className={classes.SmallTextBottomLight}>
          {this.props.smallTextBottomLeft}
        </div>
      );
    }
  };

  render() {
    let inputCss = this.props.invalid
      ? [classes.InputElement, classes.Invalid].join(' ')
      : classes.InputElement;
    if (this.props.noOutline) {
      inputCss = [inputCss, classes.NoOutline].join(' ');
    }

    if (this.props.displayAsTwoLabels && !this.props.inputStyleLeft) {
      inputCss = [inputCss, classes.CenterText].join(' ');
    }

    if (this.props.smallerPlaceholder) {
      inputCss = [inputCss, classes.InputSmallerPlaceholder].join(' ');
    }

    let inputType = this.props.type;

    if (this.props.type === 'password') {
      inputType = this.state.showPasswordText ? 'text' : 'password';
    }

    // console.log('PRPRPRPRP', this.props);

    return (
      <div className={classes.Input} style={this.props.inputStyle}>
        {this._renderLabel()}
        <input
          id={this.props.id}
          ref={this.props.setRef || 'input'}
          className={[inputCss, classes.NoSpin].join(' ')}
          value={this.props.value}
          onChange={this.props.onChange}
          type={inputType}
          pattern={this.props.pattern}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          onBlur={this.props.onBlur}
          onKeyPress={this.props.onKeyPress}
          onKeyDown={this.props.onKeyDown}
          onPaste={this.props.onPaste}
          onFocus={this.props.onFocus}
          maxLength={this.props.maxLength}
          required={this.props.required}
          inputMode={this.props.inputMode}
          autoCapitalize={this.props.autoCapitalize || 'off'}
          autoCorrect={this.props.autoCorrect || 'off'}
          autoComplete={this.props.autoComplete || 'on'}
        />
        {this._renderEyeButton()}
        {this._renderRedTriangle()}
        {this._renderSmallTextBottomLeft()}
      </div>
    );
  }
}
